module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-12-9edcf06f69cbcff0b2d159ad51a0d591.png";